<div class="rtp-page">

  <!-- Loading state -->
  <div class="rtp-loading" *ngIf="loading">
    <i class="pi pi-spin pi-spinner rtp-spinner"></i>
    <p>{{ 'bikeshop.receipt_template.print_page.preparing' | translate }}</p>
  </div>

  <!-- Error state -->
  <div class="rtp-error" *ngIf="!loading && errorMessage">
    <i class="pi pi-exclamation-triangle"></i>
    <p>{{ errorMessage }}</p>
  </div>

  <!-- Hidden canvas — rendered off-screen so the print service can capture it.
       Zoom is fixed at 100 so measurements match real mm dimensions. -->
  <div class="rtp-canvas-host" *ngIf="!loading && !errorMessage && template">
    <app-template-canvas
      [template]="template"
      [selectedElements]="[]"
      [previewMode]="false"
      [customData]="jobData"
      [zoom]="100"
      [showGrid]="false">
    </app-template-canvas>
  </div>

</div>
